import { Map, Feature } from 'ol';
import { Point } from 'ol/geom';
import { Vector } from 'ol/layer';
import { Vector as Vector_src } from "ol/source";
import { Fill, Text, Icon as Vector_icon, Style as Vector_style } from 'ol/style';
import Popup from 'ol/Overlay';

import { RVshare_RV } from "../../util/rvShareIntegration_typeDefs";
import { enlargeIcon, shrinkIcon } from '../../tripPlanner_new/map/helper_functions';

export function add_rvShareMarkers(RVs:Array<RVshare_RV>, markerLayer:Vector<Vector_src>) {
	RVs.sort(function(a,b) {
		return a.attributes.location.lat - b.attributes.location.lat
	})
	let markers:Array<Feature> = [];
	let zIndex:number = 6;
	for (let i:number = 0; i < RVs.length; i++) {
		let lat:number = RVs[i].attributes.location.lat;
		let lng:number = RVs[i].attributes.location.lng;
		let price:number = RVs[i].attributes.rate;
		let marker = new Feature(new Point([lng, lat]));

		marker.setStyle(new Vector_style({
			image: new Vector_icon({
				src: "/static/images/icons/pricePinBackground.svg",
				opacity: 1
			}),
			text: new Text({
				text: `$${price}`,
				fill: new Fill({
					color: 'white'
				}),
				font: 'bold 14px Arial',
				textAlign: 'center', // Center the text horizontally
				textBaseline: 'middle' // Center the text vertically
			}),
			zIndex: zIndex++
		}));
		marker.setProperties({
			type: "rvForRent",
			id: RVs[i].id
		})
		markers.push(marker);
	};
	markerLayer.getSource().addFeatures(markers);
};

let highlightedRVshareMarker:Feature|undefined = undefined;

export function unhighlightRVshareMarker() {
	if (highlightedRVshareMarker == undefined ) return;
	shrinkIcon(highlightedRVshareMarker,1.1);
	highlightedRVshareMarker = undefined;
};
export function highlightRVshareMarker(marker:Feature) {
	// let style:Vector_style = marker.getStyle() as Vector_style;
	enlargeIcon(marker,1.1);
	highlightedRVshareMarker = marker;
};